export default "__VITE_ASSET__Df86PoUj__"